 import { timeToTimeFull, timeToMilisegundos, diff, timeString } from "../../herramientas/DateFormat";
 const getUrgencyColor = (cita, fecha, tiempoAntesDeVencer, r, g, b ) => {    
    if(fecha !== null && fecha !== ""){
      const diff= new Date(cita).getTime() - new Date(fecha).getTime();      
      if(diff !== null && diff < 0){
        const ratio = Math.max(0, 1 - diff / tiempoAntesDeVencer);
        const alpha = (0.2 + ratio * 0.79).toFixed(2);
        return `rgba(${r}, ${g}, ${b}, ${1})`;
      }
      return 'rgba(0, 0, 0, 0)'; // sin color especial
    }else{
      const diff = new Date(cita).getTime() - new Date().getTime();      
      if (diff >= tiempoAntesDeVencer)
        return 'rgba(0, 0, 0, 0)'; // sin color especial
      if(diff !== null && diff < 0){
        return `rgba(${r}, ${g}, ${b}, ${1})`;
      }
      const ratio = Math.max(0, 1 - diff / tiempoAntesDeVencer);      
      const alpha = (0.2 + ratio * 0.79).toFixed(2);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
};
export const validarHorarios=(e, fechaString)=>{ 
    let respuesta= {
      vencida: false,
      fondo:'rgba(0, 0, 0, 0)',
      colorTexto: 'red',
      icono: 'fa fa-calendar-minus-o',
      texto: 'Calculando'
    };
    if( e.idMovimientoTipo.nombre.toLowerCase().includes("impo") || e.idMovimientoTipo.nombre.toLowerCase().includes("dist")){
      switch (fechaString) {
        case 'citaProgramada':
          if(e.citaProgramada){
            respuesta.colorTexto= 'blue';
            if(!e.arriboClienteLleno && (new Date(e.citaProgramada).getTime() - new Date().getTime()) < (1000*60*60*2)){//antes de tenere arribo
              respuesta.vencida= true;
              respuesta.fondo= 'rgba(198, 16, 16, 0.45)';//this.getUrgencyColor(e.citaProgramada, e.arriboClienteLleno, 1000*60*60*2,198,16,16);
              respuesta.texto=
                (new Date(e.citaProgramada).getTime() < new Date().getTime())
                ? 'Cita en cliente vencida('+timeString(new Date().getTime()-new Date(e.citaProgramada).getTime())+')'
                :'Cita en cliente por vencer('+timeString(new Date(e.citaProgramada).getTime()-new Date().getTime())+')';
            }
            if( e.arriboClienteLleno && (new Date(e.citaProgramada).getTime() < new Date(e.arriboClienteLleno).getTime())){//antes de tenere arribo
              respuesta.vencida= true;
              respuesta.fondo= 'rgba(255, 3, 3, 0.6)';// this.getUrgencyColor(e.citaProgramada, e.arriboClienteLleno, 1000*60*60*2,198,16,16);
              respuesta.texto= 'Cita en cliente vencida('+timeString(new Date(e.arriboClienteLleno).getTime()-new Date(e.citaProgramada).getTime())+')';
            }
          }
          break;
        case 'citaProgramadaTerminal':
          if(e.citaProgramadaTerminal){
            respuesta.colorTexto= 'green';
            if(!e.arriboDirecionCarga && (new Date(e.citaProgramadaTerminal).getTime() - new Date().getTime()) < (1000*60*60*2)){//antes de tenere arribo
              respuesta.vencida= true;
              respuesta.fondo= 'rgba(255, 3, 3, 0.6)';// this.getUrgencyColor(e.citaProgramadaTerminal, e.arriboDirecionCarga, 1000*60*60*2,198,16,16);
              respuesta.texto=
                (new Date(e.citaProgramadaTerminal).getTime() < new Date().getTime())
                ? 'Cita en centro carga vencida('+timeString(new Date().getTime()- new Date(e.citaProgramadaTerminal).getTime())+')'
                :'Cita en centro carga por vencer('+timeString(new Date(e.citaProgramadaTerminal).getTime()-new Date().getTime())+')';
            }
            if( e.arriboDirecionCarga && (new Date(e.citaProgramadaTerminal).getTime() < new Date(e.arriboDirecionCarga).getTime())){//antes de tenere arribo
              respuesta.vencida= true;
              respuesta.fondo= 'rgba(255, 3, 3, 0.6)';// this.getUrgencyColor(e.citaProgramadaTerminal, e.arriboDirecionCarga, 1000*60*60*2,198,16,16);
              respuesta.texto= 'Cita en centro carga vencida('+timeString(new Date(e.arriboDirecionCarga).getTime()-new Date(e.citaProgramadaTerminal).getTime())+')';
            }
          }
          break;      
        default:
          break;
      }
    }
    if( e.idMovimientoTipo.nombre.toLowerCase().includes("expo")){
      switch (fechaString) {
        case 'citaProgramada':
          if(e.citaProgramada){
            respuesta.colorTexto= 'blue';
            if(!e.arriboClienteVacio && (new Date(e.citaProgramada).getTime() - new Date().getTime()) < (1000*60*60*2)){//antes de tenere arribo
              respuesta.vencida= true;
              respuesta.fondo= 'rgba(255, 3, 3, 0.6)';// this.getUrgencyColor(e.citaProgramada, e.arriboClienteVacio, 1000*60*60*2,198,16,16);
              respuesta.texto= 
                (new Date(e.citaProgramada).getTime() < new Date().getTime())
                  ? 'Cita en cliente vencida('+timeString(new Date().getTime()- new Date(e.citaProgramada).getTime())+')'
                  :'Cita en cliente por vencer('+timeString(new Date(e.citaProgramada).getTime()-new Date().getTime())+')';
            }
            if( e.arriboClienteVacio && (new Date(e.citaProgramada).getTime() < new Date(e.arriboClienteVacio).getTime())){//antes de tenere arribo
              respuesta.vencida= true;
              respuesta.fondo= 'rgba(255, 3, 3, 0.6)';// this.getUrgencyColor(e.citaProgramada, e.arriboClienteVacio, 1000*60*60*2,198,16,16);
              respuesta.texto= 'Cita en cliente vencida('+timeString(new Date(e.arriboClienteVacio).getTime()-new Date(e.citaProgramada).getTime())+')';
            }
          }
          break;
        case 'citaProgramadaTerminal':
          if(e.citaProgramadaTerminal){
            respuesta.colorTexto= 'green';
            if(!e.arriboTerminalCargado && (new Date(e.citaProgramadaTerminal).getTime() - new Date().getTime()) < (1000*60*60*2)){//antes de tenere arribo
              respuesta.vencida= true;
              respuesta.fondo= 'rgba(255, 3, 3, 0.6)';// this.getUrgencyColor(e.citaProgramadaTerminal, e.arriboTerminalCargado, 1000*60*60*2,198,16,16);
              respuesta.texto= 
                (new Date(e.citaProgramadaTerminal).getTime() < new Date().getTime())
                  ? 'Cita en en centro carga vencida('+timeString(new Date().getTime()- new Date(e.citaProgramadaTerminal).getTime())+')'
                  :'Cita en en centro carga por vencer('+timeString(new Date(e.citaProgramadaTerminal).getTime()-new Date().getTime())+')';
            }
            if( e.arriboTerminalCargado && (new Date(e.citaProgramadaTerminal).getTime() < new Date(e.arriboTerminalCargado).getTime())){//antes de tenere arribo
              respuesta.vencida= true;
              respuesta.fondo= 'rgba(255, 3, 3, 0.6)';// this.getUrgencyColor(e.citaProgramadaTerminal, e.arriboTerminalCargado, 1000*60*60*2,198,16,16);
              respuesta.texto= 'Cita en centro carga vencida('+timeString(new Date(e.arriboTerminalCargado).getTime()-new Date(e.citaProgramadaTerminal).getTime())+')';
            }
          }
          break;   
        default:
          break;
      }
    }
    return respuesta;
  }